import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import SipCall from '@/data/models/domain/SipCall'

@OrmModel(modelNames.INBOUND_CALL)
export default class InboundCall extends SipCall {}
